export const getIdUser = state => state.filterEditUser.idUser;
export const getName = state => state.filterEditUser.data.name;
export const getLastName = state => state.filterEditUser.data.lastName;
export const getEmail = state => state.filterEditUser.data.email;
export const getRol = state => state.filterEditUser.data.isAdmin;
export const getState = state => state.filterEditUser.data.state;
export const getIsFetching = state => state.filterEditUser.isFetching;
export const getMessage = state => state.filterEditUser.errorMessage;
export const getSessionRol = state => state.filterEditUser.errorRol;
